import { normalize } from 'path';
import type { ReactElement } from 'react';
import ReactMarkdown from 'react-markdown';
import { Colors } from '../utils/Colors';

interface MarkdownPreviewProps {
  markdown: string;
}

export function MarkdownPreview({
  markdown,
}: MarkdownPreviewProps): ReactElement {
  return (
    <ReactMarkdown
      components={_components}
    >
      {markdown}
    </ReactMarkdown>
  );
}

const _components = {
  p: ({ children }) => (
    <p style={{ fontSize: 13, fontFamily: 'montserat, sans-serif' }}>{children}</p>
  ),
  a: ({ node, children, ...props }) => (
    <a {...props} style={{ ...props.style, color: Colors.ec2bRed }} target="_blank">{children}</a>
  ),
  img: ({ node, ...props }) => (
    <img {...props} style={{ ...props.style, width: '100%', height: 'auto' }} />
  ),
  h1: ({ children }) => (
    <h1 style={{ fontSize: 16, fontWeight: 700 }}>{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 style={{ fontSize: 14, fontWeight: 700 }}>{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 style={{ fontSize: 14, fontWeight: 400, fontStyle: 'italic' }}>{children}</h3>
  ),
  // We don't want app content with more than 3 levels. So just make the level 4+ look like level 3.
  h4: ({ children }) => (
    <h4 style={{ fontSize: 14, fontWeight: 400, fontStyle: 'italic' }}>{children}</h4>
  ),
  h5: ({ children }) => (
    <h5 style={{ fontSize: 14, fontWeight: 400, fontStyle: 'italic' }}>{children}</h5>
  ),
  h6: ({ children }) => (
    <h6 style={{ fontSize: 14, fontWeight: 400, fontStyle: 'italic' }}>{children}</h6>
  ),
}